import * as PourOver from 'pourover';

import { FilterBase, unionMembers } from './FilterBase';

export class UnspscsFilter extends FilterBase {
  needsSubset = true;

  constructor(private collection, private allUnspscIds) {
    super();
  }

  makeIndex(): any {
    return new PourOver.makeExactFilter('incumbentUnspscId', this.allUnspscIds);
  }

  getMatchSet(collection: any, filterSettings): any {
    if (filterSettings.unspscs.length) {
      return unionMembers(
        filterSettings.unspscs,
        collection.filters.incumbentUnspscId
      );
    }
  }

  getCounts(filterCombinations): any {
    let intersectionMinusUnspscs =
      filterCombinations.subsets[this.constructor.name];
    let incumbentsFilter = filterCombinations.incumbentsFilter;

    let unspscMap = new Map();

    let temp = intersectionMinusUnspscs
      ? intersectionMinusUnspscs.and(incumbentsFilter)
      : incumbentsFilter;

    this.allUnspscIds.forEach((unspscId: number) => {
      let unspscCount = temp.and(
        this.collection.filters.incumbentUnspscId.getFn(unspscId)
      ).cids.length;

      unspscMap.set(unspscId, unspscCount);
    });

    return {
      unspscCounts: Object.fromEntries(unspscMap.entries())
    };
  }
}
